/* ALEVIQUE — Theme JavaScript */
(function () {
  'use strict';

  // Column toggle (collection grid: 2 / 3 / 4 columns)
  var colBtns = document.querySelectorAll('.col-toggle .col-btn');
  var grid = document.querySelector('[data-product-grid]');
  if (colBtns.length && grid) {
    var savedCols = localStorage.getItem('alevique_grid_cols');
    if (savedCols && ['2', '3', '4'].indexOf(savedCols) !== -1) {
      applyCols(savedCols);
    }
    colBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyCols(btn.getAttribute('data-cols'));
        localStorage.setItem('alevique_grid_cols', btn.getAttribute('data-cols'));
      });
    });
    function applyCols(n) {
      grid.setAttribute('data-cols', n);
      colBtns.forEach(function (b) {
        b.classList.toggle('active', b.getAttribute('data-cols') === n);
      });
    }
  }

  // Hamburger menu toggle (mobile nav)
  var hamburger = document.getElementById('hamburger');
  var nav = document.getElementById('nav');
  if (hamburger && nav) {
    hamburger.addEventListener('click', function () {
      nav.classList.toggle('open');
    });
  }

  // Hero slider
  var slides = document.querySelectorAll('.hero .slide');
  var dots = document.getElementById('dots');
  if (slides.length && dots) {
    var hi = 0;
    slides.forEach(function (_, i) {
      var b = document.createElement('button');
      if (i === 0) b.className = 'active';
      b.onclick = function () { go(i); };
      dots.appendChild(b);
    });
    function go(i) {
      slides[hi].classList.remove('active');
      dots.children[hi].classList.remove('active');
      hi = i;
      slides[hi].classList.add('active');
      dots.children[hi].classList.add('active');
    }
    if (slides.length > 1) {
      setInterval(function () { go((hi + 1) % slides.length); }, 6500);
    }
  }

  // Scroll reveal animations
  var revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  // Product detail: gallery thumbs + deep zoom + lightbox
    var galleryImages = [];
    var currentIndex = 0;

    // Collect every gallery image (visible + high-res) once on load
    document.querySelectorAll('.thumbs .t').forEach(function (t) {
      var img = t.querySelector('img');
      var hi = t.getAttribute('onclick') || '';
      // pull the zoom URL out of the inline onclick so we don't duplicate state
      var match = hi.match(/setImg\(this,\s*'([^']+)'\s*,\s*'([^']+)'/);
      if (match && img) {
        galleryImages.push({ thumb: img.getAttribute('src'), display: match[1], zoom: match[2] });
      }
    });

    window.setImg = function (el, src, zoomSrc, index) {
      document.querySelectorAll('.thumbs .t').forEach(function (t) { t.classList.remove('active'); });
      el.classList.add('active');
      var main = document.getElementById('mainImg');
      if (main) {
        var img = main.querySelector('img');
        if (img) img.src = src;
        main.setAttribute('data-zoom-src', zoomSrc);
      }
      if (typeof index === 'number') currentIndex = index;
      resetZoom(main);
    };

    function resetZoom(main) {
      if (!main) return;
      var img = main.querySelector('img');
          var lens = document.getElementById('zoomLens');
          var result = document.getElementById('zoomResult');
          if (lens) lens.style.display = 'none';
          if (result) result.style.backgroundImage = '';
          main.classList.remove('zoom-active');
        }

        // Lens zoom (Breeze-style): circular magnifier lens + side preview
        var mainImgEl = document.getElementById('mainImg');
        var lensEl = document.getElementById('zoomLens');
        var zoomResultEl = document.getElementById('zoomResult');

        if (mainImgEl && lensEl && zoomResultEl) {
          var lensSize = 130;
          var zoomLevel = 2.5;
          var imgEl = mainImgEl.querySelector('img');
          var currentDisplaySrc = imgEl ? imgEl.getAttribute('src') : '';
          var currentHiResSrc = mainImgEl.getAttribute('data-zoom-src') || '';

          function setupZoom(src, hiRes) {
            if (!src) return;
            currentDisplaySrc = src;
            currentHiResSrc = hiRes || src;
            // Set high-res preview in result panel (browser caches it for instant hover)
            zoomResultEl.style.backgroundImage = 'url(' + currentHiResSrc + ')';
            var rect = mainImgEl.getBoundingClientRect();
            var bgW = rect.width * zoomLevel;
            var bgH = rect.height * zoomLevel;
            zoomResultEl.style.backgroundSize = bgW + 'px ' + bgH + 'px';
            // Set lens background
            lensEl.style.backgroundImage = 'url(' + currentDisplaySrc + ')';
            lensEl.style.backgroundSize = bgW + 'px ' + bgH + 'px';
          }

          // Setup once on load
          setupZoom(currentDisplaySrc, currentHiResSrc);

          // Pre-warm the high-res on first hover for instant feedback
          var prewarmed = false;
          function prewarm() {
            if (prewarmed || !currentHiResSrc) return;
            prewarmed = true;
            var p = new Image();
            p.src = currentHiResSrc;
          }

          mainImgEl.addEventListener('mouseenter', function () {
            prewarm();
            // Re-sync for the currently selected image (in case user clicked a thumb)
            var liveImg = mainImgEl.querySelector('img');
            if (liveImg && liveImg.getAttribute('src') !== currentDisplaySrc) {
              setupZoom(liveImg.getAttribute('src'), mainImgEl.getAttribute('data-zoom-src'));
            }
            // Measure current size (responsive)
            var rect = mainImgEl.getBoundingClientRect();
            var bgW = rect.width * zoomLevel;
            var bgH = rect.height * zoomLevel;
            zoomResultEl.style.backgroundImage = 'url(' + currentHiResSrc + ')';
            zoomResultEl.style.backgroundSize = bgW + 'px ' + bgH + 'px';
            lensEl.style.backgroundImage = 'url(' + currentDisplaySrc + ')';
            lensEl.style.backgroundSize = bgW + 'px ' + bgH + 'px';
            lensEl.style.display = 'block';
            mainImgEl.classList.add('zoom-active');
          });

          mainImgEl.addEventListener('mousemove', function (e) {
            var rect = mainImgEl.getBoundingClientRect();
            var x = e.clientX - rect.left;
            var y = e.clientY - rect.top;
            // Keep lens inside the image
            x = Math.max(lensSize / 2, Math.min(rect.width - lensSize / 2, x));
            y = Math.max(lensSize / 2, Math.min(rect.height - lensSize / 2, y));
            lensEl.style.left = (x - lensSize / 2) + 'px';
            lensEl.style.top  = (y - lensSize / 2) + 'px';
            // Lens background position (negative so the magnified area follows the cursor)
            var lensBgX = -(x * zoomLevel - lensSize / 2);
            var lensBgY = -(y * zoomLevel - lensSize / 2);
            lensEl.style.backgroundPosition = lensBgX + 'px ' + lensBgY + 'px';
            // Result panel position
            var resultW = zoomResultEl.offsetWidth;
            var resultH = zoomResultEl.offsetHeight;
            var resultBgX = -(x * zoomLevel - resultW / 2);
            var resultBgY = -(y * zoomLevel - resultH / 2);
            zoomResultEl.style.backgroundPosition = resultBgX + 'px ' + resultBgY + 'px';
          });

          mainImgEl.addEventListener('mouseleave', function () {
            lensEl.style.display = 'none';
            mainImgEl.classList.remove('zoom-active');
          });

          // Mobile: tap toggles lens at touch point; second tap opens lightbox
          var mobileLensVisible = false;
          mainImgEl.addEventListener('touchstart', function (e) {
            if (!e.touches || !e.touches[0]) return;
            if (mobileLensVisible) {
              // Already showing lens on mobile — second tap opens full lightbox
              lensEl.style.display = 'none';
              mobileLensVisible = false;
              mainImgEl.classList.remove('zoom-active');
              if (typeof window.openLightbox === 'function') {
                window.openLightbox(currentIndex);
              }
              return;
            }
            var rect = mainImgEl.getBoundingClientRect();
            var t = e.touches[0];
            var x = t.clientX - rect.left;
            var y = t.clientY - rect.top;
            x = Math.max(lensSize / 2, Math.min(rect.width - lensSize / 2, x));
            y = Math.max(lensSize / 2, Math.min(rect.height - lensSize / 2, y));
            var bgW = rect.width * zoomLevel;
            var bgH = rect.height * zoomLevel;
            zoomResultEl.style.backgroundImage = 'url(' + currentHiResSrc + ')';
            zoomResultEl.style.backgroundSize = bgW + 'px ' + bgH + 'px';
            lensEl.style.backgroundImage = 'url(' + currentDisplaySrc + ')';
            lensEl.style.backgroundSize = bgW + 'px ' + bgH + 'px';
            lensEl.style.left = (x - lensSize / 2) + 'px';
            lensEl.style.top  = (y - lensSize / 2) + 'px';
            lensEl.style.backgroundPosition = (-(x * zoomLevel - lensSize / 2)) + 'px ' + (-(y * zoomLevel - lensSize / 2)) + 'px';
            lensEl.style.display = 'block';
            mainImgEl.classList.add('zoom-active');
            mobileLensVisible = true;
          }, { passive: true });
        }

    // Lightbox open/close + scroll-to-zoom + arrow-key navigation
    window.openLightbox = function (index) {
      if (!galleryImages.length) return;
      var overlay = document.getElementById('lightboxOverlay');
      if (!overlay) return;
      currentIndex = index || 0;
      showLightboxImage();
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    };

    window.closeLightbox = function () {
      var overlay = document.getElementById('lightboxOverlay');
      if (!overlay) return;
      overlay.classList.remove('open');
      document.body.style.overflow = '';
      var img = document.getElementById('lightboxImg');
      if (img) { img.style.transform = 'scale(1)'; img.style.transformOrigin = '50% 50%'; }
    };

    window.lightboxNav = function (delta) {
      if (!galleryImages.length) return;
      currentIndex = (currentIndex + delta + galleryImages.length) % galleryImages.length;
      showLightboxImage();
    };

    function showLightboxImage() {
      var data = galleryImages[currentIndex];
      if (!data) return;
      var img = document.getElementById('lightboxImg');
      var counter = document.getElementById('lightboxCounter');
      if (img) {
        img.src = data.zoom;
        img.style.transform = 'scale(1)';
        img.style.transformOrigin = '50% 50%';
      }
      if (counter) counter.textContent = (currentIndex + 1) + ' / ' + galleryImages.length;
      // sync active thumb
      document.querySelectorAll('.thumbs .t').forEach(function (t, i) {
        t.classList.toggle('active', i === currentIndex);
      });
    }

    // Lightbox scroll-to-zoom (mouse wheel inside the stage)
    var stage = document.querySelector('.lightbox-stage');
    if (stage) {
      stage.addEventListener('wheel', function (e) {
        e.preventDefault();
        var img = document.getElementById('lightboxImg');
        if (!img) return;
        var current = parseFloat((img.style.transform || 'scale(1)').replace(/scale\(|\)/g, '')) || 1;
        var next = Math.min(4, Math.max(1, current + (e.deltaY < 0 ? 0.25 : -0.25)));
        img.style.transform = 'scale(' + next + ')';
      }, { passive: false });

      // Drag to pan when zoomed in
      var isDown = false, startX = 0, startY = 0, originX = 50, originY = 50;
      stage.addEventListener('mousedown', function (e) {
        var img = document.getElementById('lightboxImg');
        if (!img || img.style.transform === 'scale(1)' || !img.style.transform) return;
        isDown = true;
        startX = e.clientX; startY = e.clientY;
        var o = (img.style.transformOrigin || '50% 50%').split(' ');
        originX = parseFloat(o[0]); originY = parseFloat(o[1]);
      });
      document.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var img = document.getElementById('lightboxImg');
        if (!img) return;
        var rect = stage.getBoundingClientRect();
        var dx = ((e.clientX - startX) / rect.width) * 100;
        var dy = ((e.clientY - startY) / rect.height) * 100;
        img.style.transformOrigin = Math.max(0, Math.min(100, originX - dx)) + '% ' + Math.max(0, Math.min(100, originY - dy)) + '%';
      });
      document.addEventListener('mouseup', function () { isDown = false; });

          // ============ Mobile pinch-to-zoom + double-tap ============
          var pinchStartDistance = 0;
          var pinchStartScale = 1;
          var lastTapTime = 0;
          var lastTapX = 0, lastTapY = 0;
          var indicatorHideTimer = null;
          var panStartX = 0, panStartY = 0;
          var panOriginX = 50, panOriginY = 50;
          var isPanning = false;

          function getDistance(t1, t2) {
            var dx = t1.clientX - t2.clientX;
            var dy = t1.clientY - t2.clientY;
            return Math.sqrt(dx * dx + dy * dy);
          }

          function getMidpoint(t1, t2) {
            return {
              x: (t1.clientX + t2.clientX) / 2,
              y: (t1.clientY + t2.clientY) / 2
            };
          }

          function currentScale(img) {
            return parseFloat((img.style.transform || 'scale(1)').replace(/scale\(|\)/g, '')) || 1;
          }

          function showZoomIndicator(scale) {
            var ind = document.getElementById('zoomLevelIndicator');
            if (!ind) return;
            ind.textContent = Math.round(scale * 100) + '%';
            ind.classList.add('visible');
            if (indicatorHideTimer) clearTimeout(indicatorHideTimer);
            indicatorHideTimer = setTimeout(function () {
              ind.classList.remove('visible');
            }, 1200);
          }

          function applyZoom(scale, focalX, focalY) {
            var img = document.getElementById('lightboxImg');
            if (!img) return;
            var rect = stage.getBoundingClientRect();
            var fx = ((focalX - rect.left) / rect.width) * 100;
            var fy = ((focalY - rect.top) / rect.height) * 100;
            var newScale = Math.min(4, Math.max(1, scale));
            img.style.transformOrigin = Math.max(0, Math.min(100, fx)) + '% ' + Math.max(0, Math.min(100, fy)) + '%';
            img.style.transform = 'scale(' + newScale + ')';
            showZoomIndicator(newScale);
          }

          stage.addEventListener('touchstart', function (e) {
            var img = document.getElementById('lightboxImg');
            if (!img) return;
            if (e.touches.length === 2) {
              e.preventDefault();
              pinchStartDistance = getDistance(e.touches[0], e.touches[1]);
              pinchStartScale = currentScale(img);
              var mid = getMidpoint(e.touches[0], e.touches[1]);
              applyZoom(pinchStartScale, mid.x, mid.y);
            } else if (e.touches.length === 1) {
              var now = Date.now();
              var touch = e.touches[0];
              if (now - lastTapTime < 300 &&
                  Math.abs(touch.clientX - lastTapX) < 30 &&
                  Math.abs(touch.clientY - lastTapY) < 30) {
                e.preventDefault();
                var s = currentScale(img);
                var target = s > 1.05 ? 1 : 2.5;
                var rect = stage.getBoundingClientRect();
                var tx = Math.max(rect.left, Math.min(rect.right, touch.clientX));
                var ty = Math.max(rect.top, Math.min(rect.bottom, touch.clientY));
                applyZoom(target, tx, ty);
                lastTapTime = 0;
              } else {
                lastTapTime = now;
                lastTapX = touch.clientX;
                lastTapY = touch.clientY;
                // Start single-finger pan when already zoomed in
                if (currentScale(img) > 1.05) {
                  var o = (img.style.transformOrigin || '50% 50%').split(' ');
                  panOriginX = parseFloat(o[0]);
                  panOriginY = parseFloat(o[1]);
                  panStartX = touch.clientX;
                  panStartY = touch.clientY;
                  isPanning = true;
                }
              }
            }
          }, { passive: false });

          stage.addEventListener('touchmove', function (e) {
            var img = document.getElementById('lightboxImg');
            if (!img) return;
            if (e.touches.length === 2) {
              e.preventDefault();
              var newDistance = getDistance(e.touches[0], e.touches[1]);
              if (pinchStartDistance > 0) {
                var ratio = newDistance / pinchStartDistance;
                var newScale = pinchStartScale * ratio;
                var mid = getMidpoint(e.touches[0], e.touches[1]);
                applyZoom(newScale, mid.x, mid.y);
              }
            } else if (e.touches.length === 1 && isPanning) {
              e.preventDefault();
              var touch = e.touches[0];
              var rect = stage.getBoundingClientRect();
              var dx = ((touch.clientX - panStartX) / rect.width) * 100;
              var dy = ((touch.clientY - panStartY) / rect.height) * 100;
              // Move origin by the drag distance (inverted so image follows the finger)
              img.style.transformOrigin =
                Math.max(0, Math.min(100, panOriginX - dx)) + '% ' +
                Math.max(0, Math.min(100, panOriginY - dy)) + '%';
            }
          }, { passive: false });

          stage.addEventListener('touchend', function (e) {
            if (e.touches.length === 0) {
              pinchStartDistance = 0;
              isPanning = false;
            }
            if (e.touches.length < 2) {
              pinchStartDistance = 0;
            }
          });

          // Reset zoom on image switch so the next image loads clean
          var resetOnNav = window.lightboxNav;
          if (resetOnNav) {
            window.lightboxNav = function (delta) {
              var img = document.getElementById('lightboxImg');
              if (img) {
                img.style.transform = 'scale(1)';
                img.style.transformOrigin = '50% 50%';
              }
              resetOnNav(delta);
            };
          }
        }

    // Keyboard nav: ESC closes lightbox, arrows navigate
    document.addEventListener('keydown', function (e) {
      var overlay = document.getElementById('lightboxOverlay');
      if (!overlay || !overlay.classList.contains('open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') lightboxNav(-1);
      if (e.key === 'ArrowRight') lightboxNav(1);
    });

  // Product detail: swatch/size selection + variant resolution
  window.sel = function (el) {
    var sib = el.parentElement.querySelectorAll('.swatch, .size');
    sib.forEach(function (c) { c.classList.remove('active'); });
    el.classList.add('active');
    resolveVariant();
  };

  function selectedOptions() {
    var out = [];
    document.querySelectorAll('.options .sizes, .options .swatches').forEach(function (group) {
      var active = group.querySelector('.swatch.active, .size.active');
      out.push(active ? active.getAttribute('data-value') : null);
    });
    return out;
  }

  function resolveVariant() {
    var jsonEl = document.getElementById('variant-json');
    var select = document.getElementById('variant-select');
    if (!jsonEl || !select) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var chosen = selectedOptions();

    var match = variants.find(function (v) {
      return (v.options || []).every(function (opt, i) {
        return chosen[i] == null || chosen[i] === opt;
      });
    });
    if (!match) match = variants[0];
    var matchIndex = variants.indexOf(match);

    // Update hidden select (match by index into the same ordered variant list)
    if (select.options[matchIndex]) {
      select.selectedIndex = matchIndex;
    }

    // Swap the main image to the matched variant's image (if it has one)
    var imgsEl = document.getElementById('variant-images');
    if (imgsEl && match && match.id != null) {
      try {
        var imgs = JSON.parse(imgsEl.textContent);
        var entry = imgs.find(function (e) { return e.id === match.id; });
        if (entry && entry.src) {
          var main = document.getElementById('mainImg');
          if (main) {
            var img = main.querySelector('img');
            if (img) img.src = entry.src;
            main.setAttribute('data-zoom-src', entry.zoom || entry.src);
            resetZoom(main);
          }
          galleryImages.forEach(function (g, i) {
            if (g.display === entry.src) currentIndex = i;
          });
          document.querySelectorAll('.thumbs .t').forEach(function (t, j) {
            t.classList.toggle('active', j === currentIndex);
          });
        }
      } catch (e) { /* ignore image-swap errors */ }
    }

    // Update price display from the matching option's data attributes
    var opt = select.options[matchIndex];
    if (!opt) return;
    var priceCur = document.getElementById('price-current');
    var priceCmp = document.getElementById('price-compare');
    var priceSave = document.getElementById('price-save');
    var priceSaveAmt = document.getElementById('price-save-amount');
    if (priceCur) priceCur.textContent = opt.getAttribute('data-price');
    if (priceCmp && priceSave && priceSaveAmt) {
      if (opt.getAttribute('data-has-sale') === '1') {
        priceCmp.textContent = opt.getAttribute('data-compare-price');
        priceCmp.style.display = '';
        var cmp = parseInt(opt.getAttribute('data-compare-cents') || '0', 10);
        var cur = parseInt(opt.getAttribute('data-price-cents') || '0', 10);
        priceSaveAmt.textContent = formatMoney(cmp - cur);
        priceSave.style.display = '';
      } else {
        priceCmp.style.display = 'none';
        priceSave.style.display = 'none';
      }
    }
  }

  function formatMoney(cents) {
    if (!cents) return '';
    var money = cents / 100;
    var symbol = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : '';
    return symbol + money.toFixed(2).replace(/\.00$/, '');
  }

  // Resolve variant on load
  resolveVariant();

  // Product detail: quantity
  window.qty = function (d) {
    var input = document.getElementById('qtyVal');
    if (!input) return;
    var n = parseInt(input.value, 10) + d;
    if (n < 1) n = 1;
    input.value = n;
  };

  // Product detail: size chart modal
  window.openSizeChart = function () {
    var overlay = document.getElementById('sizeChartOverlay');
    if (!overlay) return;
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.closeSizeChart = function () {
    var overlay = document.getElementById('sizeChartOverlay');
    if (!overlay) return;
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  };
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSizeChart();
  });

  // Product detail: tabs
  window.tab = function (el, id) {
    document.querySelectorAll('.tab-btns button').forEach(function (b) { b.classList.remove('active'); });
    el.classList.add('active');
    ['tab1', 'tab2', 'tab3'].forEach(function (t) {
      var node = document.getElementById(t);
      if (node) node.style.display = (t === id) ? 'block' : 'none';
    });
  };

  // Product slider (Customer Favourites carousel)
  var sliders = document.querySelectorAll('[data-product-slider]');
  sliders.forEach(function (slider) {
    var track = slider.querySelector('.product-slider__track');
    var prev = slider.querySelector('[data-slider-prev]');
    var next = slider.querySelector('[data-slider-next]');
    var viewport = slider.querySelector('.product-slider__viewport');
    if (!track || !viewport) return;

    function step() {
      var slide = track.querySelector('.product-slider__slide');
      if (!slide) return 0;
      return slide.getBoundingClientRect().width + 20; // 20px = gap
    }

    if (next) next.addEventListener('click', function () {
      viewport.scrollBy({ left: step(), behavior: 'smooth' });
    });
    if (prev) prev.addEventListener('click', function () {
      viewport.scrollBy({ left: -step(), behavior: 'smooth' });
    });
  });

  // Quick Add (adds first available variant to cart via AJAX)
  function quickAdd(el) {
    var id = el.getAttribute('data-variant-id');
    if (!id) { window.location.href = el.getAttribute('href'); return; }
    el.classList.add('loading');
    el.querySelector('.quick-label').textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        el.querySelector('.quick-label').textContent = 'Added ✓';
        updateCartCount();
        setTimeout(function () {
          el.classList.remove('loading');
          el.querySelector('.quick-label').textContent = 'Quick Add';
        }, 1500);
      })
      .catch(function () {
        el.classList.remove('loading');
        el.querySelector('.quick-label').textContent = 'Quick Add';
        window.location.href = el.getAttribute('href');
      });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count;
        document.querySelectorAll('.tools .bag .n').forEach(function (b) { b.textContent = n; });
      })
      .catch(function () {});
  }

  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      quickAdd(btn);
    });
  });

  // Wishlist toggle (localStorage)
  var WISH_KEY = 'alevique_wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; }
  }
  function setWishlist(list) { localStorage.setItem(WISH_KEY, JSON.stringify(list)); }

  document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
    var id = btn.getAttribute('data-product-id');
    if (!id) return;
    if (getWishlist().indexOf(id) !== -1) btn.classList.add('active');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var list = getWishlist();
      var idx = list.indexOf(id);
      if (idx === -1) { list.push(id); btn.classList.add('active'); }
      else { list.splice(idx, 1); btn.classList.remove('active'); }
      setWishlist(list);
    });
  });

    // Product description View More / View Less toggle
    document.querySelectorAll('.desc-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.desc');
        if (!wrap) return;
        var full = wrap.getAttribute('data-full') || '';
        var trimmed = wrap.getAttribute('data-trimmed') || '';
        var textEl = wrap.querySelector('.desc-text');
        var expanded = wrap.classList.toggle('expanded');
        if (expanded) {
          textEl.textContent = full;
          btn.textContent = 'View Less';
          btn.setAttribute('aria-expanded', 'true');
        } else {
          textEl.textContent = trimmed;
          btn.textContent = 'View More';
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  })();
